export default class ResponseError extends Error {
  constructor(response) {
    super('Server error');
    this.response = response;
  }
}
